export const predefinedTexts = new Map([
  [
    'ΕΝ*',
    {
      title: 'Ενστάσεις 1',
      text: 'Αρνούμαστε την αίτηση κ Πρόεδρε , ως νόμο και ουσία αβάσιμη για το λόγο ότι δεν προκύπτει μόνιμη και γενική αδυναμία πληρωμών , ένσταση αοριστίας της ένδικης αίτησης, ένσταση καταχρηστικής άσκησης δικαιώματος. Προβάλουμε την ένσταση της δόλιας περιέλευσης σε κατάσταση αδυναμίας πληρωμών .Και τέλος το αίτημα ρευστοποίησης κινητής και ακίνητης περιουσίας . Κατά τα λοιπά, αναφερόμαστε αναλυτικά στις προτάσεις μας, τις οποίες καταθέτουμε επί της έδρας.'
    }
  ],
  [
    'ΑΘ*',
    {
      title: 'Όρκος άθεου',
      text: 'Κατόπιν προσήλθε ο μάρτυρας _____ εναγ_____ και είπε ότι ονομάζεται_____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών και το επάγγελμά του/της είναι_____ Δήλωσε ότι γνωρίζει τους διαδίκους, ότι δεν έχει συγγένεια με αυτούς και ότι δεν εξαρτά συμφέρον από την έκβαση της δίκης. Αφού ρωτήθηκε, δήλωσε ότι είναι άθεος κατά το άρθρο 408 παρ. 3 του Κ.Πολ.Δ. και εξεταζόμενος/η κατέθεσε τα παρακάτω: '
    }
  ],
  ['ΑΚ*', { title: 'Αδύνατη καταγραφή', text: '(ΑΔΥΝΑΤΗ ΚΑΤΑΓΡΑΦΗ) ' }],
  [
    'ΑΡΝ*',
    {
      title: 'Άρνηση αίτησης',
      text: 'Αρνούμαστε την αίτηση και ζητούμε την απόρριψη της . Θα αναλύσουμε περαιτέρω με την προσθήκη μας '
    }
  ],
  [
    'ΒΟ*',
    {
      title: 'Βεβαιωτικός όρκος',
      text: 'Κατόπιν προσήλθε ο/η καθ\'_____ η αίτηση και είπε ότι ονομάζεται _____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών, με αριθμό Δελτίου ταυτότητος_____ και το επάγγελμά του/της είναι_____ Αφού ρωτήθηκε, δήλωσε ότι είναι Χριστιανός Ορθόδοξος, ορκίστηκε στο ιερό Ευαγγέλιο κατά το άρθρο 408 του Κ.Πολ.Δ. και δέχεται να δώσει σήμερα παραχρήμα το βεβαιωτικό όρκο που του έχει επιβάλλει η υπ\' αριθ. _____ απόφαση του Ειρηνοδικείου Αθηνών. '
    }
  ],
  ['Δ*', { title: 'Δικαστής', text: 'Δικαστής: ' }],
  [
    'ΕΑ*',
    {
      title: 'Εξέταση χωρίς όρκο, ανωμοτί',
      text: 'Κατόπιν _____ Πρόεδρος κάλεσε_____ εναγ_____ που γεννήθηκε_____ κατοικεί_____ είναι _____ ετών, επαγγέλλεται_____ να τον/την εξετάσει ανωμοτί και του/της επέστησε την προσοχή ότι είναι δυνατόν να τον/την καλέσει να επιβεβαιώσει και ενόρκως τα όσα κατέθεσε. Αυτός/τη κατέθεσε ότι: '
    }
  ],
  ['ΕΜ*', { title: 'Εκτός μικροφώνου', text: '(ΕΚΤΟΣ ΜΙΚΡΟΦΩΝΟΥ) ' }],
  [
    'ΕΟΘ*',
    {
      title: 'Εξέταση με θρησκευτικό όρκο',
      text: 'Κατόπιν προσήλθε ο μάρτυρας_____ εναγ_____ και είπε ότι ονομάζεται_____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών και το επάγγελμά του είναι_____ Δήλωσε ότι γνωρίζει τους διαδίκους, ότι δεν έχει συγγένεια με αυτούς και ότι δεν εξαρτά συμφέρον από την έκβαση της δίκης. Αφού ρωτήθηκε, δήλωσε ότι είναι Χριστιανός Ορθόδοξος, ορκίστηκε στο ιερό Ευαγγέλιο κατά το άρθρο 408 του Κ.Πολ.Δ. και εξεταζόμενος κατέθεσε τα παρακάτω: '
    }
  ],
  ['ΚΜ*', { title: 'Κλειστό Μικρόφωνο', text: '(ΚΛΕΙΣΤΟ ΜΙΚΡΟΦΩΝΟ) ' }],
  [
    'ΟΑ*',
    {
      title: 'Όρκος άθεου ή πρεσβεύοντος θρησκεία που δεν επιτρέπει τον όρκο',
      text: 'Στη συνέχεια προσήλθε αφού κλήθηκε από τον Πρόεδρο ο μάρτυρας της αποδείξεως ο οποίος σε σχετικές ερωτήσεις για την ταυτότητα του αποκρίθηκε ότι ονομάζεται _____, γεννήθηκε στ_____, κάτοικος _____, οδός _____, αρ. _____, _____, Έλληνας και Χριστιανός Ορθόδοξος, γνωρίζει τον κατηγορούμενο και δεν συγγενεύει μ\' αυτόν. Στη συνέχεια ο μάρτυρας ορκίσθηκε κατά το άρθρο 220 σε συνδυασμό προς το άρθρο 218 Κ. Ποιν. Δικ. επικαλούμενος την τιμή και τη συνείδηση του και εξεταζόμεν_____ κατέθεσε τα εξής: '
    }
  ],
  [
    'ΟΔ*',
    {
      title: 'Όρκος διερμηνέα',
      text: 'Στην συνέχεια εμφανίστηκε ο μάρτυρας της αιτούσης που δήλωσε ότι δεν ξέρει την Ελληνική γλώσσα και μιλάει την _____ Μετά από αυτό η Ειρηνοδίκης κατά το άρθρο 252 Κ. Πολ. Δικ. Πήρε για διερμηνέα τον _____ γεν_____, ετών_____, επάγγελμα_____ κατ_____ Χριστιανός Ορθόδοξος που ορκίστηκε βάζοντας το δεξί του χέρι στο Ιερό Ευαγγέλιο κατά το άρθρο 408 Κ. Πολ. Δικ., ότι θα κάνει το καθήκον του ερμηνεύοντας με ακρίβεια και πιστότητα την κατάθεση του εξεταζόμενου μάρτυρα. Στην συνέχεια ο μάρτυρας είπε ότι ονομάζεται_____ γεν_____ κατ_____ ετών_____ επαγ_____, τους διαδίκους γνωρίζει, δεν συγγενεύει ούτε περιμένει συμφέρον από το αποτέλεσμα της παρούσης δίκης και δήλωσε ότι όσα θα καταθέσει είναι αληθινά και το βεβαιώνει στην συνείδησή του (αν δεν έχει θρήσκευμα.) '
    }
  ],
  [
    'ΟΗ*',
    {
      title: 'Όρκος Ισραηλίτη',
      text: 'Προσήλθε ο πρώτος μάρτυρας κατηγορίας ο οποίος, αφού ρωτήθηκε από τον Πρόεδρο για την ταυτότητα τ_____, απάντησε ότι ονομάζεται _____, του _____ και της_____, γεννήθηκε_____ την _____ στ_____ και κατοικεί στ_____, οδός _____, αριθμ_____ Επίσης δήλωσε είναι Ισραηλίτης και ότι τ_____ κατηγορούμεν_____ τ..... γνωρίζει απλώς και δεν συγγενεύει με αυτ_____ Στη συνέχεια ο μάρτυρας ορκίσθηκε επί της Ιεράς Βίβλου κατά το άρθρο 220 σε συνδυασμό προς το άρθρο 218 Κ. Ποιν. Δικ. και εξεταζόμεν_____ κατέθεσε τα εξής: '
    }
  ],
  [
    'ΟΘ*',
    {
      title: 'Όρκιση μάρτυρα με θρησκευτικό όρκο',
      text: 'Στη συνέχεια εμφανίστηκε ο μάρτυρας_____ ο οποίος σε σχετικές ερωτήσεις τ_____ Προέδρου, απάντησε ότι ονομάζεται_____, γεννήθηκε στ_____ το έτος_____ κατοικεί_____ ΑΔΤ/ΑΔ_____ επάγγελμα_____ Χριστιανός Ορθόδοξος, γνωρίζει τους διαδίκους και δε συγγενεύει με αυτούς, ούτε έχει συμφέρον από την έκβαση της δίκης. Ορκίστηκε στο Ιερό Ευαγγέλιο σύμφωνα με το άρθρο 408 παρ. 1 του Κ.Πολ.Δ και εξεταζόμενος στα θέματα της υπόθεσης αυτής, κατέθεσε τα ακόλουθα: Κείμενο όρκου:"Ορκίζομαι ενώπιον του Θεού να πω ευσυνείδητα όλη την αλήθεια και μόνο την αλήθεια, χωρίς να προσθέσω ούτε να κρύψω τίποτε". '
    }
  ],
  ['ΟΘΚ*', { title: 'Κείμενο όρκου', text: 'Κείμενο όρκου ' }],
  [
    'ΟΚ*',
    {
      title: 'Όρκος κληρικών ή ιερωμένων',
      text: 'Στη συνέχεια προσήλθε αφού κλήθηκε από τον Πρόεδρο ο μάρτυρας της αποδείξεως ο οποίος σε σχετικές ερωτήσεις για την ταυτότητα του αποκρίθηκε ότι ονομάζεται _____, γεννήθηκε στ_____, κάτοικος _____, οδός _____, αρ. _____, _____, Έλληνας και Χριστιανός Ορθόδοξος, γνωρίζει τον κατηγορούμενο και δεν συγγενεύει μ\' αυτόν. Στη συνέχεια ο μάρτυρας ορκίσθηκε κατά το άρθρο 218 Κ. Ποιν. Δικ. στην ιεροσύνη του και εξεταζόμεν_____ κατέθεσε τα εξής: '
    }
  ],
  [
    'ΟΚΑ*',
    {
      title: 'Όρκος καλόγριας',
      text: 'Κατόπιν προσήλθε ο/η μάρτυρας_____ εναγ_____ και είπε ότι ονομάζεται_____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών είναι Ιερέας, Χριστιανός Ορθόδοξος. Δήλωσε ότι γνωρίζει τους διαδίκους, ότι δεν έχει συγγένεια με αυτούς και ότι δεν εξαρτά συμφέρον από την έκβαση της δίκης. Στη συνέχεια έβαλε το χέρι του στο στήθος του και διαβεβαίωσε επί της Ιεροσύνη του κατ\' το άρθρο 408 του Κ.Πολ.Δ. ότι θα καταθέσει την αλήθεια και εξεταζόμενος κατέθεσε τα παρακάτω: '
    }
  ],
  [
    'ΟΜ*',
    {
      title: 'Όρκος Μουσουλμάνου',
      text: 'Κατόπιν προσήλθε ο/η μάρτυρας_____ εναγ_____ και είπε ότι ονομάζεται_____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών και το επάγγελμά του/της είναι_____ Δήλωσε ότι γνωρίζει τους διαδίκους, ότι δεν έχει συγγένεια με αυτούς και ότι δεν εξαρτά συμφέρον από την έκβαση της δίκης. Αφού ρωτήθηκε, δήλωσε ότι είναι Μουσουλμάνος, ορκίστηκε στο Ιερό Κοράνι και εξεταζόμενος/η κατέθεσε τα παρακάτω: '
    }
  ],
  [
    'ΟΟ*',
    {
      title: 'Όρκος Οθωμανού',
      text: 'Προσήλθε ο πρώτος μάρτυρας κατηγορίας ο οποίος, αφού ρωτήθηκε από τον Πρόεδρο για την ταυτότητα τ_____, απάντησε ότι ονομάζεται _____, του _____ και της _____, γεννήθηκε την _____, στ_____ και κατοικεί στ_____, οδός _____, αριθμ_____ Επίσης δήλωσε είναι Μωαμεθανός και ότι τ_____ κατηγορούμεν_____ τ..... γνωρίζει απλώς και δεν συγγενεύει με αυτ_____ Στη συνέχεια ο μάρτυρας ορκίσθηκε επί του Κορανίου κατά το άρθρο 220 σε συνδυασμό προς το άρθρο 218 Κ. Ποιν. Δικ. και εξεταζόμενος κατέθεσε τα εξής: '
    }
  ],
  [
    'ΟΠ*',
    {
      title: 'Όρκιση μάρτυρα με πολιτικό όρκο',
      text: 'Κατόπιν προσήλθε ο/η μάρτυρας_____ εναγ_____ και είπε ότι ονομάζεται_____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών και το επάγγελμά του/της είναι_____ Δήλωσε ότι γνωρίζει τους διαδίκους, ότι δεν έχει συγγένεια με αυτούς και ότι δεν εξαρτά συμφέρον από την έκβαση της δίκης. Αφού ρωτήθηκε, ορκίστηκε διαβεβαιώνοντας στην τιμή και στην συνείδησή του/της κατά το άρθρο 408 του Κ.Πολ.Δ. και εξεταζόμενος/νη κατέθεσε τα παρακάτω: '
    }
  ],
  [
    'ΟΡΙ*',
    {
      title: 'Όρκος για ιερέα Πολ. Δικ.',
      text: 'Κατόπιν προσήλθε ο/η μάρτυρας_____ εναγ_____ και είπε ότι ονομάζεται_____ Γεννήθηκε_____ κατοικεί_____ είναι _____ ετών είναι Ιερέας, Χριστιανός Ορθόδοξος. Δήλωσε ότι γνωρίζει τους διαδίκους, ότι δεν έχει συγγένεια με αυτούς και ότι δεν εξαρτά συμφέρον από την έκβαση της δίκης. Στη συνέχεια έβαλε το χέρι του στο στήθος του και διαβεβαίωσε επί της Ιεροσύνη του κατ\' το άρθρο 408 του Κ.Πολ.Δ. ότι θα καταθέσει την αλήθεια και εξεταζόμενος κατέθεσε τα παρακάτω: '
    }
  ],
  ['ΠΔ*', { title: 'Παρίσταται διά', text: 'Παρίσταται διά ' }],
  ['ΠΔΙ*', { title: 'Παράλληλοι Διάλογοι', text: '(ΠΑΡΑΛΛΗΛΟΙ ΔΙΑΛΟΓΟΙ) ' }],
  ['ΠΜ*', { title: 'Παρίσταται μετά', text: 'Παρίσταται μετά ' }],
  ['ΤΕΛ*', { title: 'Αδυναμία Καταγραφής Κειμένου', text: '(...) ' }]
])

export const getPredefinedTexts = () => {
  return Array.from(predefinedTexts.entries()).map(([shortcut, data]) => ({
    shortcut,
    title: data.title,
    text: data.text
  }))
}

export const checkForPredefinedText = (text) => {
  // Trim whitespace for more reliable matching
  const trimmedText = text.trim()

  return predefinedTexts.has(trimmedText) ? predefinedTexts.get(trimmedText).text : text
}
